import React from 'react';

const FitProfile = () => {
  return (
    <div
      className="mb-32 inline-block overflow-hidden rounded-[32px] border-8 border-white"
      style={{ boxShadow: 'rgb(182, 182, 182) 0px 36px 35px' }}
    >
      <div className="aspect-ratio-9by16">
        <img
          loading="lazy"
          width={235}
          src="https://gentux.imgix.net/1630087328_fitprofilescreenshotmock210827135333.png?fm=jpg&auto=format&fit=crop&w=235&dpr=2"
          alt="generation tux mobile screen shot of fit profile"
        />
      </div>
    </div>
  );
};

export default FitProfile;
